import {LatLngExpression} from 'leaflet'
import React from 'react'
import {DraggableMarker} from './DraggableMarker'
import {GenericMap} from './GenericMap'

interface Props {
  onPositionChange: (lat: number, long: number) => void
  initialMarkerPosition: LatLngExpression
}

export const EditableMap: React.FC<Props> = ({initialMarkerPosition, onPositionChange}) => {
  console.log('[EditableMap] initialMarkerPosition =', initialMarkerPosition)
  return (
    <GenericMap initialPosition={initialMarkerPosition}>
      <DraggableMarker initialPosition={initialMarkerPosition} onPositionChange={onPositionChange} />
    </GenericMap>
  )
}
